import { Box, Chip, ChipProps } from '@mui/material';
import { styled } from '@mui/material/styles';

export const ReviewRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: '1.5rem',
  padding: '1.5rem 1rem',
  borderBottom: `1px solid ${theme.palette.disabled.main}`,
  '&:last-of-type': {
    borderBottom: 'none',
  },
}));

export const ReviewLabel = styled(Box)(({ theme }) => ({
  flex: '0 0 20%',
  fontSize: '1.125rem',
  color: theme.palette.text.disabled,
}));

export const ReviewValue = styled(Box)(({ theme }) => ({
  flex: '1 1 auto',
  minWidth: 0,
  fontSize: '1.125rem',
  color: theme.palette.monochrome.monoChrome6,
  display: 'flex',
  flexWrap: 'wrap',
  gap: '0.5rem',
  alignItems: 'center',
}));

export const ReviewChip = styled(Chip)<ChipProps>(({ theme }) => ({
  height: '2rem',
  borderRadius: '1rem',
  backgroundColor: theme.palette.monochrome.monoChrome2,
  color: theme.palette.monochrome.monoChrome6,
  fontSize: '1.125rem',
  fontWeight: 400,
}));
